<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-09-29 17:13:39

 * @FilePath: /streamline_detail/src/views/home/components/newProductBaseInfo/usuallyInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="usually-info" :class="{ 'price-style': priceStatus == 1 }">
    <div class="product-header">
      <!-- 价格信息区域 -->
      <goods-price-component
        :handPriceVo="handPriceVo"
        :fineDiscount="fineDiscount"
        :costPerformanceText="costPerformanceText"
        :dataInfo="dataInfo"
      ></goods-price-component>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, watch } from '@vue/composition-api'
import goodsPriceComponent from './goods-price-component'

export default defineComponent({
  components: {
    goodsPriceComponent
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    feedbackData: {
      type: Object,
      default: () => {}
    },
    priceStatus: {
      type: Number,
      default: 0
    },
    costPerformanceText: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const handPriceVo = computed(() => {
      return props.dataInfo.handPriceVo
    })
    const fineDiscount = computed(() => {
      return props.dataInfo?.costPerformanceExplain?.priceTag
    })

    watch(
      () => props.dataInfo,
      (val) => {
        if (val.title) {
          // 设置class为usually-info的高度为auto
          document.getElementsByClassName('usually-info')[0].style.height = 'auto'
        }
      }
    )
    return {
      handPriceVo,
      fineDiscount
    }
  }
})
</script>

<style lang="scss" scoped>
.usually-info {
  box-sizing: border-box;
  width: 100%;
  height: 208px;
  margin-bottom: 12px;
  padding: 24px 24px 26px;
  padding-right: 0;
  background: #f8f8f8;
  border-radius: 32px 16px 16px;
  &.price-style {
    padding-bottom: 24px;
  }

  .product-header {
    display: flex;
    flex-direction: column;
  }
}
</style>
